import React, { useContext, useEffect, useState } from "react";
import { Review } from "Components/Review/Review";
import { Module, ModuleCaption } from "Components/Module";
import { useModulePager } from "Hooks";
import { PortalClient, RatingViewModel } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import ModulePager from "../ModulePager";
import ModulePagerControls from "../ModulePager/ModulePagerControls";
import AccountContext from "../../AccountContext";

export const ReviewsModule: React.FC = () => {
   const account = useContext(AccountContext);
   const portalClient = useApiClient(PortalClient);
   const [colleaguesWithReviewCount, setColleaguesWithReviewCount] = useState(0);
   const [reviews, setReviews] = useState<RatingViewModel[]>([]);

   const pager = useModulePager({
      itemCount: reviews.length,
      itemWidth: 548,
      gapWidth: 24
   });


   const loadReviewsData = async (abortSignal: AbortSignal) => {
      try {
         const reviewsData = await portalClient.reviews(account.id, abortSignal);
         setReviews(reviewsData.reviews || []);
         setColleaguesWithReviewCount(reviewsData.colleaguesWithReviewCount);
      }
      catch { }
   }

   useEffect(() => {
      const abortController = new AbortController();
      loadReviewsData(abortController.signal);

      return function cleanup() {
         abortController.abort();
      }
   }, []);

   if (colleaguesWithReviewCount < 1)
      return (null);

   return (<Module size="lg" withPager>
      <ModuleCaption className="mb-px32">Activity from your colleagues
         <ModulePagerControls pager={pager} />
      </ModuleCaption>
      {<ModulePager
         pager={pager}
         items={reviews}
         renderItem={(review, style) => <Review
            key={review.id}
            className="portal-review"
            review={review}
            style={style}
         />}
      />}
   </Module>);
}